import { createAsyncThunk } from "@reduxjs/toolkit";
import AxiosDefaultSetting from "../AxiosDefault";

//get permmision
export const getAllPermission = createAsyncThunk(
  "permission/roles",
  async (data, { rejectWithValue }) => {
    const { order_type, order_by, page_size, page, search_text, ...rest } =
      data;
    const queryString = new URLSearchParams({
      order_type,
      order_by,
      page_size,
      page,
      search_text,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/roles?${queryString}`, //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//get permmision details
export const getAllPermissionDetails = createAsyncThunk(
  "permission/permissionOptions",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/role-permissions/${data}`, //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
